import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";

export function B11({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XCL001.error_id: {
            return `RS ${row.cross_section}: XS GIS CutLine points can not parse!`
        }
        case MessageCodes.Internal.XCL002.error_id: {
            return (
                <>
                    <ResultText>
                        There are {row?.data?.length} cross sections where Cutline Length is not equal to Cross-Section Length. These cross-sections and corresponding cutline length ratios (r) are listed in the following table. If the length ratio is due to an applied skew, the r value is highlighted in green text.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Length Ratio, r</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={r.cross_section} /> {r.skew ? ` (skew ${r?.skew})` : ''}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            <div style={{color: (1/Math.cos(r?.skew * Math.PI / 180)).toPrecision(3) === parseFloat(r?.ratio).toPrecision(3) ? 'green' : ''}}>
                                                {r.ratio}
                                            </div>
                                        </ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XCL003.error_id: {
            return (
                <>
                    <div>
                        Cutline Length could not be calculated for the following {row?.data?.length} cross sections since they are not georeferenced:
                    </div>
                    <div>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </div>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}